<template>

  <div>
    <!-- ======= Top Bar ======= -->
    <div id="topbar" class="d-none d-lg-flex align-items-center">
      <div class="container d-flex">
        <div class="container">
          <div class="row">
            <div class="offset-md-1 col-md-8">
              <img src="assets/img/logo.png">
            </div>
            <div class="col-md-3">
              <div class="btn-group">
                <button type="button" class="btn manu-button button-english">ENG</button>
                <button type="button" class="btn manu-button button-bangla">বাংলা</button>
              </div>
              <div>
                <router-link :to="{name: 'doctorLogin'}" type="button" class="btn manu-button button-login">Login/signup</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ======= Header ======= -->
    <header id="header" >

      <div class="container d-flex align-items-center nhcss">

        <nav class="nav-menu d-none d-lg-block"
             :class="{ 'navbar--hidden': !showNavbar }">
          <ul>
            <li><a href="#about">My Profile</a></li>
            <li><a href="#services">Health Directory</a></li>
            <li><a href="#departments">Hospital Discount</a></li>
            <li><a href="#doctors">Features</a></li>
            <li style="border: none !important; "><a href="#contact">Contact</a></li>

          </ul>
        </nav><!-- .nav-menu -->
      </div>
    </header><!-- End Header -->
    <router-view></router-view>
    <footer id="footer">

      <div class="footer-top">
        <div class="container">
          <div class="row">

            <div class="col-lg-3 col-md-6 footer-contact">
              <h3>Medilab</h3>
              <p>
                A108 Adam Street <br>
                New York, NY 535022<br>
                United States <br><br>
                <strong>Phone:</strong> +1 5589 55488 55<br>
                <strong>Email:</strong> info@example.com<br>
              </p>
            </div>

            <div class="col-lg-2 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Home</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">About us</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Services</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Terms of service</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Privacy policy</a></li>
              </ul>
            </div>

            <div class="col-lg-3 col-md-6 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Web Design</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Web Development</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Product Management</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Marketing</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Graphic Design</a></li>
              </ul>
            </div>

            <div class="col-lg-4 col-md-6 footer-newsletter">
              <h4>Join Our Newsletter</h4>
              <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
              <form action="" method="post">
                <input type="email" name="email"><input type="submit" value="Subscribe">
              </form>
            </div>

          </div>
        </div>
      </div>

      <div class="container d-md-flex py-4">

        <div class="mr-md-auto text-center text-md-left">
          <div class="copyright">
            &copy; Copyright <strong><span>Innova Tech</span></strong>. All Rights Reserved
          </div>
          <div class="credits">
            <!-- All the links in the footer should remain intact. -->
            <!-- You can delete the links only if you purchased the pro version. -->
            <!-- Licensing information: https://bootstrapmade.com/license/ -->
            <!-- Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/medilab-free-medical-bootstrap-theme/ -->
<!--            Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>-->
          </div>
        </div>
        <div class="social-links text-center text-md-right pt-3 pt-md-0">
          <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
          <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
          <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
          <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
          <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
        </div>
      </div>
    </footer><!-- End Footer -->


    <!--  Calling modal-->
    <b-modal v-model="showCallDialog"
             centered title="Incoming Call"
             no-close-on-backdrop no-close-on-esc
    >
      <template v-slot:default="">
        <p>Incoming Call from Patient</p>
      </template>
      <template v-slot:modal-footer="{}">
        <!-- Emulate built in modal footer ok and cancel button actions -->

        <b-button size="sm" variant="success" @click="moveToCallPage">
          Accept
        </b-button>

        <b-button size="sm" variant="danger" @click="setCallInfo(null)">
          Cancel
        </b-button>
        <!-- Button with custom close trigger value -->
      </template>
    </b-modal>
    <!--  Calling modal-->
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import DoctorService from "@/services/general_user/doctor.service";

const ringtone = new Audio('@/assets/sounds/ringtone.wav');

export default {

  name: 'GeneralUserLayout',
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    // title: function () {
    //   return {
    //     inner: this.title
    //   }
    // },
    link: [
      { rel: 'stylesheet', href: 'assets/vendor/bootstrap/css/bootstrap.min.css'},
      { rel: 'stylesheet', href: 'assets/vendor/icofont/icofont.min.css'},
      { rel: 'stylesheet', href: 'assets/vendor/boxicons/css/boxicons.min.css'},
      { rel: 'stylesheet', href: 'assets/vendor/venobox/venobox.css'},
      { rel: 'stylesheet', href: 'assets/vendor/animate.css/animate.min.css'},
      { rel: 'stylesheet', href: 'assets/vendor/remixicon/remixicon.css'},
      { rel: 'stylesheet', href: 'assets/vendor/owl.carousel/assets/owl.carousel.min.css'},
      { rel: 'stylesheet', href: 'assets/vendor/bootstrap-datepicker/css/bootstrap-datepicker.min.css'},
      { rel: 'stylesheet', href: 'assets/css/style.css'},
      // ...
    ],
    script: [
      // { type: 'text/javascript', src: '/assets/vendor/jquery/jquery.min.js', async: true, body: true}, // Insert in body
      // {type: 'text/javascript', src: '/assets/vendor/bootstrap/js/bootstrap.bundle.min.js', async: false, body: true}, // Insert in body
      // {type: 'text/javascript', src: '/assets/vendor/jquery.easing/jquery.easing.min.js', async: false, body: true}, // Insert in body
      // {type: 'text/javascript', src: '/assets/vendor/php-email-form/validate.js', async: false, body: true}, // Insert in body
      // {type: 'text/javascript', src: '/assets/vendor/venobox/venobox.min.js', async: false, body: true}, // Insert in body
      // {type: 'text/javascript', src: '/assets/vendor/waypoints/jquery.waypoints.min.js', async: false, body: true}, // Insert in body
      // {type: 'text/javascript', src: '/assets/vendor/counterup/counterup.min.js', async: false, body: true}, // Insert in body
      // {type: 'text/javascript', src: '/assets/vendor/owl.carousel/owl.carousel.min.js', async: false, body: true}, // Insert in body
      // {
      //   type: 'text/javascript',
      //   src: '/assets/vendor/bootstrap-datepicker/js/bootstrap-datepicker.min.js',
      //   async: false,
      //   body: true
      // }, // Insert in body
      // {type: 'text/javascript', src: '/assets/js/template.js', async: false, body: true}, // Insert in body
    ],
  },
  data() {
    return {
      showCallDialog: false,
      showNavbar: true,
      lastScrollPosition: 0
    }
  },
  methods: {
    ...mapActions('generalUserCheckup', ['initializeFirebaseListener', 'setCallInfo']),
    ...mapActions('generalUserDoctor', ['setdoctortype']),
    fetchDoctorTypes() {
      DoctorService.fetchDoctorTypes()
          .then((response) => {
            if (response.status === 200) {
              this.setdoctortype(response.data);
            }
          })
    },
    moveToCallPage() {

      let routeData = this.$router.resolve({
        name: 'patientCheckup',
        params: {patientcheckup_code: this.getCallInfo.checkup_code}
      });
      window.open(routeData.href, '_blank', 'location=yes,channelmode=yes,fullscreen=yes,scrollbars=yes,status=yes');
    },

    onScroll () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    }
  },
  computed: {
    ...mapGetters('generalUserAuth', ['getUser']),
    ...mapGetters('generalUserCheckup', ['isCallIncoming', 'getCallInfo']),
  },
  watch: {
    isCallIncoming: function (newVal) {
      this.showCallDialog = newVal;
      if (newVal) {
        ringtone.play();
      } else {
        this.showCallDialog = false;
        ringtone.pause();
        ringtone.currentTime = 0;
      }
    }
  },
  mounted() {
    this.fetchDoctorTypes();
    window.addEventListener('scroll', this.onScroll)

    // var btn = document.getElementById("ringtone_btn");
    // btn.addEventListener("click", function () {
    //   document.getElementById('my_ringtone').play();
    //   document.getElementById('my_ringtone').muted = false;
    //   console.log('asasd');
    // });
    // btn.click();

    //
    // if (this.getUser) {
    //   this.initializeFirebaseListener(this.getUser.code);
    // }
  },
  created() {
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)

  }
};
</script>

<style src="./GeneralUserLayout.scss" lang="scss"/>
